import * as _ from "lodash";
import { Components } from "formiojs";

const SignatureComponent  = Components.components.signature;

export default class MiproSignatureField  extends SignatureComponent   {

    static schema() {
        return SignatureComponent.schema({
            type: "miproSignatureField",
            label: "Signature",
            key: "dbo.mipro.miproSignature",
            placeholder: "Please sign here", 
            disabled: false,
            minWidth: 0.5,
            maxWidth: 0.5, 
            input: true,
             validate: {
                 required: false 
             },
          });
    }

    init() {
        super.init();
    }

    static get builderInfo() {
        return {
            title: "Signature",
            group: "basic",
            icon: "pencil-alt",
            weight: 70,
            schema: MiproSignatureField.schema(),            
        };
    }
}

Components.addComponent("miproSignatureField", MiproSignatureField);